// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav.navbar {
  background-color: var(--dark) !important;
  border-bottom: 1px solid var(--white);
}
nav.navbar .navbar-brand {
  gap: 0.625rem;
  height: auto;
}
nav.navbar .navbar-brand img {
  height: 3rem;
}
nav.navbar .navbar-brand span:first-child {
  font-size: 1rem;
}
nav.navbar .navbar-brand span:last-child {
  font-size: 0.875rem;
}
nav.navbar .botones {
  gap: 0.5rem;
  flex-wrap: wrap;
}
nav.navbar .dropdown-menu a {
  color: #212529 !important;
}
nav.navbar > button {
  position: absolute;
  display: none;
  color: var(--white);
}

@media (max-width: 991.98px) {
  nav.navbar > div > div {
    flex-direction: column;
  }
  nav.navbar .botones {
    justify-content: center;
    padding: 0.5rem 0;
  }
}
@media (max-width: 767.98px) {
  nav.navbar > button {
    display: flex;
    align-self: flex-start;
    top: 1rem;
    right: 1rem;
    border: none;
    width: min-content;
    padding: 0.3rem !important;
  }
  nav.navbar > button:focus {
    box-shadow: none;
  }
  nav.navbar > div > div {
    flex-direction: column;
    /* align-items: flex-start !important; */
    gap: 1rem;
    padding: 0.5rem 0;
  }
  nav.navbar > div > div .botones {
    flex-wrap: nowrap;
  }
  nav.navbar > div > div .botones .dropdown > a {
    margin-bottom: 0;
  }
  .btn {
    margin: 0;
  }
}
@media (max-width: 575.98px) {
  nav.navbar .navbar-brand {
    flex-direction: column;
  }
  nav.navbar .navbar-brand span {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,qCAAA;AACF;AAAE;EACE,aAAA;EACA,YAAA;AAEJ;AADI;EACE,YAAA;AAGN;AADI;EACE,eAAA;AAGN;AADI;EACE,mBAAA;AAGN;AAAE;EACE,WAAA;EACA,eAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAEJ;;AAEA;EAEI;IACE,sBAAA;EAAJ;EAEE;IACE,uBAAA;IACA,iBAAA;EAAJ;AACF;AAIA;EAEI;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,0BAAA;EAHJ;EAII;IACE,gBAAA;EAFN;EAKE;IACE,sBAAA;IACA,wCAAA;IACA,SAAA;IACA,iBAAA;EAHJ;EAII;IACE,iBAAA;EAFN;EAGM;IACE,gBAAA;EADR;EAMA;IACE,SAAA;EAJF;AACF;AAOA;EACE;IACE,sBAAA;EALF;EAME;IACE,kBAAA;EAJJ;AACF","sourcesContent":["nav.navbar {\n  background-color: var(--dark) !important;\n  border-bottom: 1px solid var(--white);\n  & .navbar-brand {\n    gap: 0.625rem;\n    height: auto;\n    & img {\n      height: 3rem;\n    }\n    & span:first-child {\n      font-size: 1rem;\n    }\n    & span:last-child {\n      font-size: 0.875rem;\n    }\n  }\n  & .botones {\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n  & .dropdown-menu a {\n    color: #212529 !important;\n  }\n  & > button {\n    position: absolute;\n    display: none;\n    color: var(--white);\n  }\n}\n\n@media (max-width: 991.98px) {\n  nav.navbar {\n    & > div > div {\n      flex-direction: column;\n    }\n    & .botones {\n      justify-content: center;\n      padding: 0.5rem 0;\n    }\n  }\n}\n\n@media (max-width: 767.98px) {\n  nav.navbar {\n    & > button {\n      display: flex;\n      align-self: flex-start;\n      top: 1rem;\n      right: 1rem;\n      border: none;\n      width: min-content;\n      padding: 0.3rem !important;\n      &:focus {\n        box-shadow: none;\n      }\n    }\n    & > div > div {\n      flex-direction: column;\n      /* align-items: flex-start !important; */\n      gap: 1rem;\n      padding: 0.5rem 0;\n      & .botones {\n        flex-wrap: nowrap;\n        & .dropdown > a {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n  .btn {\n    margin: 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  nav.navbar .navbar-brand {\n    flex-direction: column;\n    & span {\n      text-align: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
